<template>
  <PageContainer v-if="doc" class="bg-grey">
    <template #header>
      <DefaultGrid class="pt-14 md:pt-24">
        <div class="col-span-full">
          <div class="mx-auto max-w-7xl space-y-16 md:space-y-24">
            <div class="flex flex-col items-center space-y-8 text-center">
              <span
                class="type-label uppercase text-black/50"
                v-text="
                  $dayjs(doc.publishedAt || doc.createdAt).format('D MMMM YYYY')
                "
              />
              <h1 class="type-heading-1" v-text="doc.title" />
              <span class="type-label uppercase" v-text="category?.name" />
            </div>
            <div class="aspect-[4/3] overflow-hidden rounded-xl">
              <PayloadImage
                class="h-full w-full object-cover"
                :image="doc.image"
                :sizes="{
                  default: '90vw',
                  '2xl': '1280px',
                }"
              />
            </div>
          </div>
        </div>
      </DefaultGrid>
    </template>
    <template #main>
      <DefaultGrid class="py-14 md:py-28 xl:py-32">
        <div class="col-span-full">
          <div class="rich-text mx-auto max-w-3xl leading-[1.5em]">
            <PayloadRichText
              :content="doc.content"
              :image-sizes="{
                default: '90vw',
                lg: '768px',
              }"
            />
          </div>
        </div>
      </DefaultGrid>
    </template>
  </PageContainer>
</template>

<script setup lang="ts">
const route = useRoute()

const initialData = await usePayloadResourceArticle(route.params.slug as string)
const { data: doc } = useLivePreview({ initialData })

const category = useRelationshipField(doc.value?.category)
</script>

<style scoped lang="postcss">
.rich-text :deep(a) {
  @apply font-medium text-purple;
}
</style>
